import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ButtonWrapper } from '../styles';
import {
  TableHeader,
  OptionButton,
  TableData,
  Wrapper,
} from '../../users/styles';

const ListViewHeader = ({ gigger = false, customer = false }) => (
  <>
    <Wrapper className="row m-0">
      {!customer && (
      <TableData className="col ">
        <TableHeader>
          <FormattedMessage id="common_company" defaultMessage="Company" />
        </TableHeader>
      </TableData>
      )}

      <TableData className="col">
        <TableHeader>
          <FormattedMessage id="common_user" defaultMessage="User" />
        </TableHeader>
      </TableData>

      {!gigger && (
      <TableData className="col">
        <TableHeader>
          <FormattedMessage id="common_gigger" defaultMessage="Gigger" />
        </TableHeader>
      </TableData>
      )}

      <TableData className="col">
        <TableHeader>
          <FormattedMessage id="common_comments" defaultMessage="Comments" />
        </TableHeader>
      </TableData>

      <TableData className="col">
        <TableHeader>
          <FormattedMessage id="common_rating" defaultMessage="Rating" />
        </TableHeader>
      </TableData>

      <TableData className="col">
        <TableHeader>
          <FormattedMessage id="common_created" defaultMessage="Created" />
        </TableHeader>
      </TableData>

      <TableData className="col">
        <TableHeader>
          <FormattedMessage id="common_last_edit" defaultMessage="Last edit" />
        </TableHeader>
      </TableData>

      <TableData className="col-auto text-align">
        <ButtonWrapper>
          <TableHeader>
            <FormattedMessage id="common_status" defaultMessage="Status" />
          </TableHeader>
        </ButtonWrapper>
      </TableData>

      <TableData className="col-auto">
        <OptionButton />
      </TableData>
    </Wrapper>
  </>
);
export default ListViewHeader;
